import React, { CSSProperties } from "react"
import autobind from "class-autobind"
import { SelectField, MenuItem, Toggle } from "material-ui"
import strings from "../../localization/strings"
import hierarchySettingsStore from "../../stores/HierarchySettingsStore"
import * as payrollHelper from "../../helpers/payrollHelper"
import * as api from "../../api"
import * as permissionHelper from "../../helpers/permissionHelper"
import { IPayrollItemForAccountLevel, IHierarchyItem, IJobDocument, IUserPayrollData, EOTType, EPayCalendarTypes } from "../../models"
import _ from "lodash"
import AppStateStore from "../../stores/AppStateStore"
import AccountStore from "../../stores/AccountStore"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"

interface IProps {
    width?: number | string
    employeePayrollHierarchyItemId?: string
    employeeDefaultJob: IJobDocument
    employeeDefaultPunchHierarchyItemId: string
    employeePayrollPayGroupId?: string
    employeePayrollPayGroupManualSet?: boolean
    employeeOTPolicyId?: string
    employeeOTPolicyManualSet?: boolean
    updateUserPayrollHierarchy?: boolean
    disabled?: boolean
    userId?: string
    style?: CSSProperties
    labelStyle?: CSSProperties
    floatingLabelStyle?: CSSProperties
    toggleStyle?: CSSProperties
    handleChange?(payrollHierarchyId: string, payrollPayGroupId: string, payrollPayGroupManualSet: boolean, otPolicyId: string, otPolicyManualSet: boolean, errorOTPolicyId: boolean): void
}
interface IState {
    employeePayrollHierarchyItem: IPayrollItemForAccountLevel | IHierarchyItem
    employeePayrollPayGroupManualSet: boolean
    employeePayrollPayGroupId: string
    employeeOTPolicyId: string
    errorEmployeeOTPolicyId: string
    employeeOTPolicyManualSet: boolean
    selectablePayrollHierarchyItems: (IPayrollItemForAccountLevel | IHierarchyItem)[]
}

export default class PayrollSelection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        // employeePayrollPayGroupId  is not null in UserForm
        // employeePayrollPayGroupId  is null in AddUserDialog and AddAccountUserDialog
        const employeePayrollPayGroupId = this.getPayrollPayGroupId(props.employeePayrollHierarchyItemId, props.employeePayrollPayGroupId, props)
        const employeeOTPolicyId = payGroupAndTypeHelper.getOTPolicyId(props.employeePayrollHierarchyItemId, props.employeeDefaultPunchHierarchyItemId, props.employeeDefaultJob, employeePayrollPayGroupId, props.employeeOTPolicyManualSet ? props.employeeOTPolicyId : null)

        this.state = {
            employeePayrollHierarchyItem: null,
            employeePayrollPayGroupManualSet: props.employeePayrollPayGroupManualSet ? true : false,
            employeePayrollPayGroupId: employeePayrollPayGroupId,
            employeeOTPolicyId,
            errorEmployeeOTPolicyId: "",
            employeeOTPolicyManualSet: props.employeeOTPolicyManualSet ? true : false,
            selectablePayrollHierarchyItems: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.getSelectablePayrollHierarchyItemsAndEmployeePayrollHierarchy(this.props)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.employeePayrollHierarchyItemId !== nextProps.employeePayrollHierarchyItemId && this.getSelectablePayrollHierarchyItemsAndEmployeePayrollHierarchy(nextProps)
        const employeePayrollPayGroupId = this.getPayrollPayGroupId(this.state.employeePayrollHierarchyItem ? this.state.employeePayrollHierarchyItem.Id : null, null, nextProps)
        if (!this.state.employeePayrollPayGroupManualSet) {
            this.setState({ employeePayrollPayGroupId })
        }
        if (!this.state.employeeOTPolicyManualSet) {
            this.setState({ employeeOTPolicyId: payGroupAndTypeHelper.getOTPolicyId(nextProps.employeePayrollHierarchyItemId, nextProps.employeeDefaultPunchHierarchyItemId, nextProps.employeeDefaultJob, employeePayrollPayGroupId, nextProps.employeeOTPolicyManualSet ? nextProps.employeeOTPolicyId : null) })
        }
    }

    setTooltipOnPayrollSelector() {
        (document.getElementById("PayrollSelection").firstChild as HTMLElement).setAttribute("title", this.state.employeePayrollHierarchyItem ? this.state.employeePayrollHierarchyItem.Label : strings.Invalid_Payroll)
    }

    getSelectablePayrollHierarchyItemsAndEmployeePayrollHierarchy(props) {
        const selectablePayrollHierarchyItems = payrollHelper.getSelectablePayrollHierarchyItems()
        this.setState({
            selectablePayrollHierarchyItems,
            employeePayrollHierarchyItem: props.updateUserPayrollHierarchy ?
                (selectablePayrollHierarchyItems as any[]).find((item) => item.Id === props.employeePayrollHierarchyItemId) :
                payrollHelper.getAutoAssignPayrollHierarchyItem(hierarchySettingsStore.getGlobalLevelItemFilterId(), selectablePayrollHierarchyItems)
        }, () =>
            this.setTooltipOnPayrollSelector()
        )
    }

    handleChangePayroll(employeePayrollHierarchyItem, employeePayrollPayGroupId: string, employeePayrollPayGroupManualSet: boolean, employeeOTPolicyId: string, employeeOTPolicyManualSet: boolean) {
        if (
            (this.state.employeePayrollHierarchyItem && this.state.employeePayrollHierarchyItem.Id === employeePayrollHierarchyItem.Id) &&
            (this.state.employeePayrollPayGroupId === employeePayrollPayGroupId)
        ) {
            this.savePayroll(employeePayrollHierarchyItem, employeePayrollPayGroupId, employeePayrollPayGroupManualSet, employeeOTPolicyId, employeeOTPolicyManualSet)
            return
        }

        this.props.updateUserPayrollHierarchy ?
            api.checkCanChangeEmployeePayrollPayGroupData(this.props.userId, { PayrollHierarchyItemId: employeePayrollHierarchyItem.Id, PayrollPayGroupId: employeePayrollPayGroupId }).then(res =>
                res.data === true ?
                    AppStateStore.setConfirmDialogContent({
                        title: strings.Change_Employee_Payroll,
                        content: strings.Do_you_want_to_change_payroll,
                        confirm: () => this.savePayroll(employeePayrollHierarchyItem, employeePayrollPayGroupId, employeePayrollPayGroupManualSet, employeeOTPolicyId, employeeOTPolicyManualSet)
                    }) :
                    permissionHelper.isGlobalAdmin() ?
                        AppStateStore.setConfirmDialogContent({
                            title: strings.Change_Employee_Payroll,
                            content: strings.Change_payroll_as_GlobalAdmin,
                            confirm: () => this.savePayroll(employeePayrollHierarchyItem, employeePayrollPayGroupId, employeePayrollPayGroupManualSet, employeeOTPolicyId, employeeOTPolicyManualSet)
                        }) :
                        AppStateStore.setConfirmDialogContent({
                            title: strings.Warning,
                            confirmBtnLabel: strings.contact_support,
                            content: strings.warning_change_pay_group_context,
                            confirm: () => {
                                window.location.href = "mailto:support@findd.io?subject=Change PayGroup Requirement&body=Please write your requirement in here.";
                            }
                        })
            ) :
            this.savePayroll(employeePayrollHierarchyItem, employeePayrollPayGroupId, employeePayrollPayGroupManualSet, employeeOTPolicyId, employeeOTPolicyManualSet)
    }

    getPayrollPayGroupId(payrollHierarchyItemId: string, payrollPayGroupId: string, props: IProps): string {
        const userPayrollData: IUserPayrollData = {
            Id: props.userId,
            PayrollHierarchyItemId: payrollHierarchyItemId,
            DefaultPunchHierarchyId: props.employeeDefaultPunchHierarchyItemId,
            DefaultJobId: props.employeeDefaultJob ? props.employeeDefaultJob.Id : null,
            PayrollPayGroupId: payrollPayGroupId
        }
        return payGroupAndTypeHelper.getPayGroupIdByUserPayrollData(userPayrollData, props.employeeDefaultJob)
    }

    savePayroll(payrollHierarchyItem: IPayrollItemForAccountLevel | IHierarchyItem, payrollPayGroupId: string, employeePayrollPayGroupManualSet: boolean, otPolicyId: string, employeeOTPolicyManualSet: boolean) {
        const employeePayrollPayGroupId = this.getPayrollPayGroupId(payrollHierarchyItem.Id, payrollPayGroupId, this.props)
        const employeeOTPolicyId = payGroupAndTypeHelper.getOTPolicyId(payrollHierarchyItem ? payrollHierarchyItem.Id : null, this.props.employeeDefaultPunchHierarchyItemId, this.props.employeeDefaultJob, employeePayrollPayGroupId, employeeOTPolicyManualSet ? otPolicyId : null)
        this.setState({
            employeePayrollHierarchyItem: payrollHierarchyItem,
            employeePayrollPayGroupId,
            employeePayrollPayGroupManualSet,
            employeeOTPolicyId,
            employeeOTPolicyManualSet
        }, () => {
            this.setTooltipOnPayrollSelector()
            const otPolicyIdValid = this.checkOTPolicyValidate()
            this.props.handleChange &&
                this.props.handleChange(payrollHierarchyItem.Id, employeePayrollPayGroupId, employeePayrollPayGroupManualSet, employeeOTPolicyId, employeeOTPolicyManualSet, !otPolicyIdValid)
        })
    }

    checkOTPolicyValidate() {
        let isValid = true
        if (AccountStore.getEnableOTPolicy()) {
            if (!this.state.employeeOTPolicyId) {
                this.setState({ errorEmployeeOTPolicyId: strings.This_field_is_required })
                isValid = false
            }
            else if (
                AccountStore.getCurrentAccount().OTPolicies.find(i => i.Id === this.state.employeeOTPolicyId).Type === EOTType.Bi_Weekly &&
                payGroupAndTypeHelper.getPayGroupById(this.state.employeePayrollPayGroupId).PaySettings.PayCalendarType !== EPayCalendarTypes.Biweekly
            ) {
                this.setState({ errorEmployeeOTPolicyId: strings.Cannot_choose_Bi_Weekly_OT_policy })
                isValid = false
            }
            else {
                this.setState({ errorEmployeeOTPolicyId: null })
            }
        }
        return isValid
    }

    render() {
        return (
            <div>
                <SelectField
                    data-intercom-target={"AccountUsers-Add-Select-PayrollHierarchy"}
                    id="PayrollSelection"
                    floatingLabelText={strings.Payroll_Hierarchy}
                    value={this.state.employeePayrollHierarchyItem}
                    onChange={(event, index, value) => this.handleChangePayroll(value, null, this.state.employeePayrollPayGroupManualSet, this.state.employeeOTPolicyId, this.state.employeeOTPolicyManualSet)}
                    style={{ ...this.props.style, width: this.props.width ? this.props.width : 256 }}
                    labelStyle={this.props.labelStyle ? this.props.labelStyle : { paddingRight: 30 }}
                    iconStyle={{ width: 40 }}
                    floatingLabelStyle={this.props.floatingLabelStyle}
                    disabled={this.props.disabled}
                    errorText={this.state.employeePayrollHierarchyItem === undefined && strings.Invalid_Payroll}
                >
                    {this.state.selectablePayrollHierarchyItems.map((item, index) =>
                        <MenuItem
                            value={item}
                            key={index}
                            primaryText={
                                <div className="TextOverflow">
                                    <span style={{ fontWeight: 600 }}>{(item as IPayrollItemForAccountLevel).DefinitionLabel}</span> <span>{item.Label}</span>
                                </div>
                            }
                        />
                    )}
                </SelectField>
                {AccountStore.getEnablePayGroupAssignEmployeeLevel() &&
                    <div style={{ ...this.props.style, display: "flex", alignItems: "baseline", marginTop: -5 }}>
                        <SelectField
                            data-intercom-target={"AccountUsers-Add-Select-PayrollPayGroup"}
                            id="PayrollPayGroupSelection"
                            floatingLabelText={strings.Pay_Group_Selection}
                            value={this.state.employeePayrollPayGroupId}
                            onChange={(event, index, value) => this.handleChangePayroll(this.state.employeePayrollHierarchyItem, value, this.state.employeePayrollPayGroupManualSet, this.state.employeeOTPolicyId, this.state.employeeOTPolicyManualSet)}
                            style={{ width: this.props.width ? this.props.width : 256 }}
                            labelStyle={this.props.labelStyle ? this.props.labelStyle : { paddingRight: 30 }}
                            iconStyle={{ width: 40 }}
                            floatingLabelStyle={this.props.floatingLabelStyle}
                            disabled={this.props.disabled || !this.state.employeePayrollPayGroupManualSet}
                            selectionRenderer={(payGroupId) => {
                                const payGroup = AccountStore.getCurrentAccount().PayGroups.find(i => i.Id === payGroupId)
                                if (payGroup) {
                                    const payGroupTitle = `${payGroup.Name} (${this.state.employeePayrollPayGroupManualSet ? strings.Manual_Override : strings.Inherited})`
                                    return <div className="TextOverflow" title={payGroupTitle}>{payGroupTitle}</div>
                                }
                                else {
                                    return strings.Error
                                }
                            }}
                        >
                            {AccountStore.getCurrentAccount().PayGroups
                                .filter(i => !i.Deleted)
                                .map((item, index) =>
                                    <MenuItem
                                        value={item.Id}
                                        key={index}
                                        primaryText={item.Name}
                                    />
                                )
                            }
                        </SelectField>
                        <Toggle
                            data-intercom-target={"AccountUsers-Add-Enable-PayrollPayGroup"}
                            label={strings.Set_Pay_Group_Manually}
                            style={{ ...this.props.toggleStyle, width: this.props.width ? this.props.width : 256, marginLeft: 10 }}
                            disabled={this.props.disabled}
                            toggled={this.state.employeePayrollPayGroupManualSet}
                            onToggle={(e, value) => this.handleChangePayroll(this.state.employeePayrollHierarchyItem, value ? this.state.employeePayrollPayGroupId : null, value, this.state.employeeOTPolicyId, this.state.employeeOTPolicyManualSet)}
                        />
                    </div>
                }
                {AccountStore.getEnableOTPolicy() &&
                    <div style={{ ...this.props.style, display: "flex", alignItems: "baseline", marginTop: -5 }}>
                        <SelectField
                            data-intercom-target={"AccountUsers-Select-OT-Policy"}
                            id="PayrollOTPolicySelection"
                            floatingLabelText={strings.OT_Policy}
                            value={this.state.employeeOTPolicyId}
                            onChange={(event, index, value) => this.handleChangePayroll(this.state.employeePayrollHierarchyItem, this.state.employeePayrollPayGroupId, this.state.employeePayrollPayGroupManualSet, value, this.state.employeeOTPolicyManualSet)}
                            style={{ width: this.props.width ? this.props.width : 256 }}
                            labelStyle={this.props.labelStyle ? this.props.labelStyle : { paddingRight: 30 }}
                            iconStyle={{ width: 40 }}
                            floatingLabelStyle={this.props.floatingLabelStyle}
                            disabled={this.props.disabled || !this.state.employeeOTPolicyManualSet}
                            selectionRenderer={(otPolicyId) => {
                                const otPolicy = AccountStore.getCurrentAccount().OTPolicies.find(i => i.Id === otPolicyId)
                                if (otPolicy) {
                                    let otPolicyTitle = otPolicy.Name
                                    if (this.state.employeeOTPolicyManualSet) {
                                        otPolicyTitle += ` (${strings.Manual_Override})`
                                    }
                                    else {
                                        const inheritedHierarchyJobItem = hierarchyHelper.getInheritedHierarchySettingItems(this.props.employeeDefaultJob ? this.props.employeeDefaultJob : hierarchyHelper.getHierarchyItemById(this.props.employeeDefaultPunchHierarchyItemId)).OTPolicySettings
                                        const isAccountLevel = inheritedHierarchyJobItem ? false : true
                                        const hierarchyJobItem = isAccountLevel ? AccountStore.getCurrentAccount() : inheritedHierarchyJobItem
                                        if (hierarchyJobItem.HierarchyItemSettings && hierarchyJobItem.HierarchyItemSettings.OTPolicySettings && hierarchyJobItem.HierarchyItemSettings.OTPolicySettings.OTPolicyId === otPolicyId) {
                                            const isJobSettings = hierarchyJobItem.hasOwnProperty("AccountId")
                                            if (isJobSettings) {
                                                otPolicyTitle += ` (${strings.inheritance_override} - ${this.props.employeeDefaultJob.Name})`
                                            }
                                            else {
                                                otPolicyTitle += isAccountLevel ?
                                                    ` (${strings.inheritance_override} - ${strings.Account})` :
                                                    ` (${strings.inheritance_override} - ${strings.Hierarchy}: ${(hierarchyJobItem as IHierarchyItem).Label})`
                                            }
                                        }
                                        else {
                                            const payGroup = AccountStore.getCurrentAccount().PayGroups.find(i => i.Id === this.state.employeePayrollPayGroupId)
                                            otPolicyTitle += ` (${strings.inherited} - ${payGroup.Name})`
                                        }
                                    }
                                    return <div className="TextOverflow" title={otPolicyTitle}>{otPolicyTitle}</div>
                                }
                                else {
                                    return strings.Error
                                }
                            }}
                            errorText={this.state.errorEmployeeOTPolicyId}
                        >
                            {AccountStore.getCurrentAccount().OTPolicies
                                .filter(i => !i.Deleted)
                                .map((item, index) =>
                                    <MenuItem
                                        value={item.Id}
                                        key={index}
                                        primaryText={item.Name}
                                    />
                                )
                            }
                        </SelectField>
                        <Toggle
                            data-intercom-target={"AccountUsers-Add-Enable-OT-Policy"}
                            label={strings.Set_OT_Policy_Manually}
                            style={{ ...this.props.toggleStyle, width: this.props.width ? this.props.width : 256, marginLeft: 10 }}
                            disabled={this.props.disabled}
                            toggled={this.state.employeeOTPolicyManualSet}
                            onToggle={(e, value) => this.handleChangePayroll(this.state.employeePayrollHierarchyItem, this.state.employeePayrollPayGroupId, this.state.employeePayrollPayGroupManualSet, this.state.employeeOTPolicyId, value)}
                        />
                    </div>
                }
            </div>
        )
    }
}
